<template>
    <v-expansion-panel class="accordion-item">
        <v-expansion-panel-header class="px-1 px-sm-5">
            <v-row class="my-1" style="max-height: 50px;">
                <v-col class="px-xs-0" style="max-width: 40px">
                    <v-checkbox
                        class="mt-0 pt-0"
                        color="orange lighten-2"
                        @click.native="notUnwrap"
                        @change="changeDrugState"
                    >
                    </v-checkbox>
                </v-col>
                <v-col class="px-xs-0">
                    <router-link class="text-caption text--main-yellow text-sm-body-2 font-sm-10-px"
                                 :to="{ name: 'product', params: {
                            parentCategory: product.parentCategorySysName,
                            category: product.categorySystemName,
                            sysNameWithId: `${product.productSystemName}-${product.id}`
                        }}" target="_blank"
                    >
                        {{product.productName }}
                    </router-link>
                </v-col>
                <v-col class="px-xs-0"><span class="text-caption text-sm-body-2 font-sm-10-px">{{product.producer}}</span></v-col>
                <v-col class="px-xs-0"><span class="text-caption text-sm-body-2 font-sm-10-px">{{currency.symbol}} {{ numberFormat(this.pricePerValue) }} / га</span></v-col>
                <v-col class="d-none d-sm-flex" v-if="!manualRate"><span>{{product.attributes.numericAttribute.min_value}} {{product.attributes.numericAttribute.unit_name}}</span></v-col>
                <v-col class="d-none d-sm-flex" v-if="!manualRate">
                    <v-slider
                        step="0.05"
                        @click.native="notUnwrap($event)"
                        v-model="usageRate"
                        :min="product.attributes.numericAttribute.min_value"
                        :max="product.attributes.numericAttribute.max_value"
                        ticks="always"
                        :thumb-size="24"
                        thumb-label="always"
                        thumb-color="main--yellow"
                        track-color="main--grey"
                        track-fill-color="main--yellow"
                    ></v-slider>
                </v-col>
                <v-col class="d-none d-sm-flex" v-if="!manualRate" style="max-width: 95px"><span>{{product.attributes.numericAttribute.max_value}} {{product.attributes.numericAttribute.unit_name}}</span></v-col>
                <v-col class="d-none d-sm-flex" v-if="manualRate"><span>{{ $t('norm') }}: {{usageRate}} {{product.attributes.numericAttribute.unit_name}}</span></v-col>
                <v-col class="d-none d-sm-flex pt-2" v-if="!manualRate">
                    <v-btn
                        depressed
                        text
                        class="caption text--main-yellow"
                        justify="center"
                        @click.native="manualRateInput"
                    >
                        {{ $t('manualEntry') }}
                    </v-btn>
                </v-col>
                <v-col class="d-none d-sm-flex pt-2" cols="4" v-if="manualRate">
                    <v-btn
                        depressed
                        text
                        class="caption text--main-yellow"
                        justify="center"
                        @click="openRateDialog = true"
                    >
                        {{ $t('change') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-divider></v-divider>
            <v-row class="d-flex d-sm-none pt-8 pb-4" v-if="!manualRate">
                <v-col><span class="font-sm-10-px">{{product.attributes.numericAttribute.min_value}} {{product.attributes.numericAttribute.unit_name}}</span></v-col>
                <v-col class="slider-height" v-if="!manualRate">
                    <div>
                        <v-slider
                            step="0.05"
                            v-model="usageRate"
                            @click.native="notUnwrap($event)"
                            :min="product.attributes.numericAttribute.min_value"
                            :max="product.attributes.numericAttribute.max_value"
                            ticks="always"
                            :thumb-size="24"
                            thumb-label="always"
                            thumb-color="main--yellow"
                            track-color="main--grey"
                            track-fill-color="main--yellow"
                        ></v-slider>
                    </div>
                    <div class="">
                        <v-btn
                            depressed
                            text
                            class="caption text--main-yellow"
                            @click.native="manualRateInput"
                        >
                            {{ $t('manualEntry') }}
                        </v-btn>
                    </div>
                </v-col>
                <v-col><span class="font-sm-10-px">{{product.attributes.numericAttribute.max_value}} {{product.attributes.numericAttribute.unit_name}}</span></v-col>
            </v-row>
            <v-row justify="center" class=" d-flex d-sm-none mt-0" v-if="manualRate">
                <v-col cols="10">
                    <span>{{ $t('norm') }}: {{usageRate}} {{product.attributes.numericAttribute.unit_name}}</span>
                    <v-btn
                        depressed
                        text
                        class="caption text--main-yellow"
                        @click="openRateDialog = true"
                    >
                        {{ $t('change') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="col-md-6">
                    <div>
                        <v-row class="pt-md-3">
                            <v-col cols="7" class="col-md-9"><span class="font-weight-bold text-sm-body-2 font-sm-10-px">{{ $t('requiredQuantity') }}</span></v-col>
                            <v-col cols="5" class="col-md-3"><span class="text-sm-body-2 font-sm-10-px">{{ requiredQuantity.toFixed(2) }} {{product.pack.unitName}}</span></v-col>
                        </v-row>
                        <v-divider></v-divider>
                    </div>
                    <div>
                        <v-row class="pt-3">
                            <v-col cols="7" class="col-md-9"><span class="font-weight-bold text-sm-body-2 font-sm-10-px">{{ $t('recommendedAccordingPacking') }}</span></v-col>
                            <v-col cols="5" class="col-md-3"><span class="text-sm-body-2 font-sm-10-px">{{ recommendedAmount.toFixed(2) }} {{ product.pack.unitName }}</span></v-col>
                        </v-row>
                        <v-divider></v-divider>
                    </div>
                    <div>
                        <v-row class="pt-3">
                            <v-col cols="7" class="col-md-9"><span class="font-weight-bold text-sm-body-2 font-sm-10-px">{{ $t('costPerHectare') }}</span></v-col>
                            <v-col cols="5" class="col-md-3"><span class="text-sm-body-2 font-sm-10-px">{{ currency.symbol }} {{ numberFormat(pricePerValue) }}</span></v-col>
                        </v-row>
                        <v-divider></v-divider>
                    </div>
                </v-col>
                <v-col cols="12" class="col-md-6">
                    <div>
                        <v-row class="pt-3">
                            <v-col cols="7"><span class="font-weight-bold text-sm-body-2 font-sm-10-px">{{ $t('commonCost') }} ({{hectares}} га)</span></v-col>
                            <v-col cols="5"><span class="text-sm-body-2 font-sm-10-px">{{ currency.symbol }} {{ numberFormat(priceWithoutPolicyDiscount) }}</span></v-col>
                        </v-row>
                        <v-divider></v-divider>
                    </div>
                    <div>
                        <v-row class="pt-3">
                            <v-col cols="7"><span class="font-weight-bold text-sm-body-2 font-sm-10-px">{{ $t('discountByCommercialPolicy') }}</span></v-col>
                            <v-col cols="5"><span class="text-sm-body-2 font-sm-10-px">{{ policyDiscountPercent }}%</span></v-col>
                        </v-row>
                        <v-divider></v-divider>
                    </div>
                    <div>
                        <v-row class="pt-3">
                            <v-col cols="7"><span class="font-weight-bold text-sm-body-2 font-sm-10-px">{{ $t('summaryCost') }}</span></v-col>
                            <v-col cols="5"><span class="text-sm-body-2 font-sm-10-px">{{ currency.symbol }} {{ numberFormat(priceWithPolicyDiscount) }}</span></v-col>
                        </v-row>
                        <v-divider></v-divider>
                    </div>
                </v-col>
            </v-row>
            <div class="text-right text-caption font-italic py-1">{{ ndsLabel }}</div>
            <div class="d-flex justify-center py-2">
                <v-btn
                    depressed
                    :disabled="selectedAttributes.length === 0"
                    text
                    class="caption text--main-yellow"
                    justify="center"
                    @click="openEnumAttributesDialog = true"
                >{{ $t('problems') }}</v-btn>
            </div>
            <div class="d-flex justify-center py-2">
                <v-btn
                    depressed
                    :disabled="inBasket"
                    class="caption white--text main--yellow"
                    justify="center"
                    @click="addToBasket"
                >{{ basketButtonTitle }}</v-btn>
            </div>
            <product-usage-rate-dialog
                :is-open="openRateDialog"
                :rate="usageRate"
                :recommendedMin="product.attributes.numericAttribute.min_value"
                :recommendedMax="product.attributes.numericAttribute.max_value"
                :unitName="product.attributes.numericAttribute.unit_name"
                @close="openRateDialog = false"
                @sendRate="setRate"
            ></product-usage-rate-dialog>
            <product-enum-attributes-dialog
                :is-open="openEnumAttributesDialog"
                @close="openEnumAttributesDialog = false"
                :selectedAttributes="selectedAttributes"
                :productName="product.productName"
                :productEnumAttributes="product.attributes.enumAttributes"
            ></product-enum-attributes-dialog>
        </v-expansion-panel-content>
        <v-snackbar
            v-model="snackOpen"
            centered
        >
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    text
                    icon
                    v-bind="attrs"
                    @click="closeSnack"
                >
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-expansion-panel>
</template>

<script>
import ProductUsageRateDialog from "../../../../app-front/components/dialogs/ProductUsageRateDialog";
import ProductEnumAttributesDialog from "../../../../app-front/components/dialogs/ProductEnumAttributesDialog";

import CalculatorDataProvider from "../../../../app-front/mixins/CalculatorDataProvider";
import AddToBasket from "../../../../app-front/mixins/AddToBasket";
import NoLoginBasket from "../../../../app-front/mixins/NoLoginBasket";
import AppSnack from "../../../../general/mixins/AppSnack";


import BasketService from "../../../../app-front/services/api/BasketService";
import numberFormat from "../../../../utils/numberFormat";

export default {
    name: "AccordionItem",
    components: { ProductUsageRateDialog, ProductEnumAttributesDialog },
    mixins: [ CalculatorDataProvider, AddToBasket, NoLoginBasket, AppSnack ],
    props: [  'calculationIdx', 'treatmentIdx', 'drugIdx', 'product', 'selectedAttributes' ],
    data() {
        return {
            manualRate: false,
            openRateDialog: false,
            openEnumAttributesDialog: false,
            usageRate: null,
        }
    },
    computed: {
        calculationData() {
            return this.calculatorFullData[this.calculationIdx];
        },
        hectares() {
            return this.calculationData.hectaresCnt || 0;
        },
        currency() {
            return this.$store.getters.currencies.find(item=>item.name === this.$store.getters.appCurrency);
        },
        inBasket() {
            return (this.isBasket(this.product.id) || this.isInNoLoginBasket(this.product.id));
        },
        basketButtonTitle() {
            return this.inBasket ? this.$t('alreadyInBasket') : `${this.$t('addToBasket')} ${this.recommendedAmount} ${this.product.pack.unitName}`;
        },
        formattedDrug() {
            return  {
                id: this.product.id,
                productName: this.product.productName,
                producer: this.product.producer,
                requiredQuantity: this.requiredQuantity,
                recommendedAmount: this.recommendedAmount,
                priceWithoutPolicyDiscount: this.priceWithoutPolicyDiscount,
                policyDiscountPercent: this.policyDiscountPercent,
                priceWithPolicyDiscount: this.priceWithPolicyDiscount,
                NDS: this.product.price.withNds,
                pricePerValue: this.pricePerValue,
                quantity: this.recommendedAmountQuantity
            }
        },
        minPack() {
            return this.product.pack.value * this.product.pack.minValue
        },
        ndsLabel() {
            return this.product.price.withNds ? this.$t('priceWithNds') : this.$t('priceWithoutNds')
        },
        priceWithoutPolicyDiscount() {
            return this.product.price[this.currency.name] * (1 - this.product.price.discountPercent / 100) * this.product.pack.minValue * this.recommendedAmountQuantity
        },
        priceWithPolicyDiscount() {
            return this.product.price[this.currency.name] * (1 - (this.product.price.discountPercent + this.policyDiscountPercent) / 100)* this.product.pack.minValue * this.recommendedAmountQuantity
        },
        pricePerValue() {
            return (this.product.price[this.currency.name]/this.product.pack.value*this.usageRate);
        },
        policyDiscountPercent() {
            let policyDiscount = 0;

            if (this.product.policies.amountPolicy.length === 0) {
                return policyDiscount;
            }
            this.product.policies.amountPolicy.forEach(item=>{
                if(item.currency === this.currency.id){
                    if(this.priceWithoutPolicyDiscount >= item.minSum && this.priceWithoutPolicyDiscount <= item.maxSum) {
                        policyDiscount = item.discount;
                    }
                }
            })
            return policyDiscount;
        },
        requiredQuantity() {
            return this.hectares * this.usageRate;
        },
        recommendedAmount() {
            return this.recommendedAmountQuantity * this.minPack;
        },
        recommendedAmountQuantity() {
            return Math.ceil(this.requiredQuantity / this.minPack);
        },
    },
    methods: {
        addToBasket() {
            if(this.isUserLoggedIn) {
                BasketService.updateList([this.basketItem])
                    .then(res => {
                        this.$store.commit('setBasket', res.data);
                        this.snackText = this.$t('addProductSuccess');
                        this.openSnack();
                    })
                    .catch(err => console.log(err));
            } else {
                this.addToNoLoginBasket([this.basketItem]);
                this.snackText = this.$t('addProductSuccess');
                this.openSnack();
            }
        },
        changeDrugState(state) {
            this.$emit('change-drug-state', {
                basketDrug: this.formattedDrug,
                state: state
            });
        },
        notUnwrap(event) {
            event.cancelBubble = true;
        },
        setRate(rate) {
            this.usageRate = rate > 0 ? rate : 0;
        },
        numberFormat(price) {
            return numberFormat(price, 2, '.', ' ')
        },
        manualRateInput() {
            this.openRateDialog = true;
            this.manualRate = true;
        },
    },
    created(){
        this.usageRate = this.product.attributes.numericAttribute.min_value;
    },
    watch: {
        pricePerValue() {
            this.$emit('mutate-drug', this.formattedDrug)
        }
    }
}
</script>

<style lang="scss">
    .accordion-item:before {
        box-shadow: none;
    }
    .slider-height {
        height: 5px;
    }
    @media screen and (max-width: 400px) {
        .font-sm-10-px {
            font-size: 12px;
        }
    }
</style>
